/*!

=========================================================
* Paper Kit React - v1.3.2
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-react

* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React from "react";
import { Link } from "react-router-dom"; // Import Link for internal navigation

// reactstrap components
import { Row, Container } from "reactstrap";

// Renamed function to IndexFooter
function IndexFooter() {
  return (
    <footer className="footer footer-black footer-white">
      <Container>
        <Row>
          {/* Removed the original navigation */}
          {/* Centered the credits and copyright info */}
          <div className="credits mx-auto"> {/* Use mx-auto for centering */}
            <span className="copyright">
              Created by Nigel Robin | Copyright © {new Date().getFullYear()} Solis Indago
              &nbsp;|&nbsp; {/* Added space and separator */}
              <Link to="/admin-login">Admin Login</Link> {/* Added Link to Admin Login */}
            </span>
          </div>
        </Row>
      </Container>
    </footer>
  );
}

// Export the new component name
export default IndexFooter;